import { createAction, createApiAction } from '@saucelabs/sl-util-redux';

import * as types from './types';
import * as api from './api';

export const changePage = createAction(types.CHANGE_PAGE);
export const resetPage = createAction(types.RESET_PAGE);
export const updateQuery = createAction(types.UPDATE_QUERY);
export const updateFilter = createAction(types.UPDATE_FILTER);
export const changeUrlQueryToFilter = createAction(types.CHANGE_URL_QUERY_TO_FILTERS);

export const fetchFilters = createApiAction(
  types.FETCH_FILTERS,
  (params) => api.fetchFilters(params),
  { meta: { skipErrorPage: true } },
);

export const getUsers = createApiAction(
  types.GET_USERS,
  () => api.getUsers(),
  { meta: { skipErrorPage: true } },
);

export const getTeams = createApiAction(
  types.GET_TEAMS,
  () => api.getTeams(),
  { meta: { skipErrorPage: true } },
);
